import React from "react";
import Heading from "../Common/Heading/Heading";
import Paragraph from "../Common/Heading/Paragraph";

const ContentSection = () => {
  return (
    <div className="employers-cv-content">
      <Heading level={2} className="text-center">
        Let Employers Find You
      </Heading>
      <div className="bar"></div>
      <Paragraph text="Advertise your jobs to millions of monthly users and search 15.8 million CV in our database." />
    </div>
  );
};

export default ContentSection;
